module.exports = __webpack_public_path__ + "static/media/Gannon.22f02490.png";